module.exports = __webpack_public_path__ + "static/media/md-images.16c79cf3.svg";